export enum OrderTaskPositionAssigneeType {
    Employee = 'employee',
    Department = 'department',
    External = 'external',
}

export interface OrderTaskPositionAssigneePayload {
    assigneeType: OrderTaskPositionAssigneeType | null;
    bcm_employees_id: number | null;
    bcm_departments_id: number | null;
    externalCompanyName: string | null;
}

const ASSIGNEE_TYPES = new Set<string>(Object.values(OrderTaskPositionAssigneeType));

export function normalizeOrderTaskPositionAssigneeType(
    value: unknown,
): OrderTaskPositionAssigneeType | null {
    if (value === null || value === undefined || value === '') {
        return null;
    }

    const normalized = String(value).trim().toLowerCase();

    return ASSIGNEE_TYPES.has(normalized)
        ? normalized as OrderTaskPositionAssigneeType
        : null;
}

export function clearConflictingAssigneeFields(
    assigneeType: OrderTaskPositionAssigneeType | null,
): OrderTaskPositionAssigneePayload {
    if (!assigneeType) {
        return {
            assigneeType: null,
            bcm_employees_id: null,
            bcm_departments_id: null,
            externalCompanyName: null,
        };
    }

    return {
        assigneeType,
        bcm_employees_id: assigneeType === OrderTaskPositionAssigneeType.Employee ? null : null,
        bcm_departments_id: assigneeType === OrderTaskPositionAssigneeType.Department ? null : null,
        externalCompanyName: assigneeType === OrderTaskPositionAssigneeType.External ? null : null,
    };
}

export function getOrderTaskPositionAssigneeLabel(
    payload: OrderTaskPositionAssigneePayload,
    employeeNameById: Record<number, string>,
    departmentNameById: Record<number, string>,
): string | null {
    if (!payload.assigneeType) {
        return null;
    }

    if (payload.assigneeType === OrderTaskPositionAssigneeType.Employee && payload.bcm_employees_id) {
        return employeeNameById[payload.bcm_employees_id] || null;
    }

    if (payload.assigneeType === OrderTaskPositionAssigneeType.Department && payload.bcm_departments_id) {
        return departmentNameById[payload.bcm_departments_id] || null;
    }

    if (payload.assigneeType === OrderTaskPositionAssigneeType.External) {
        return payload.externalCompanyName;
    }

    return null;
}
